export default __webpack_public_path__ + "static/media/Boots of the Amaranthine Drums.53a13241.jpg";